import NextLink from 'next/link';
import {useRouter} from 'next/router';
import {Button, Container, Flex, Text} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';
import {getCountry} from '@eksab/util/helpers';

import {CrownIcon, StarsEyesIcon} from '../icons';
import {useTriviaStore} from '../state';

export function DemoWinner() {
  const {locale} = useRouter();

  const t = useTranslate();
  const challenge = useTriviaStore((state) => state.challenge!);
  const returnURL = useTriviaStore((state) => `/play/${state.game?.route}`);
  const prevAppLanguage = useTriviaStore((state) =>
    state.prevAppLanguage ? `${state.prevAppLanguage}-${getCountry(locale)}` : undefined,
  );

  return (
    <Container
      flex="1"
      flexDir={['column', null, null, 'row']}
      gap={[5, null, null, 24]}
      alignItems="center"
      justifyContent={['start', null, null, 'center']}
    >
      <StarsEyesIcon width={[260, null, null, 400]} height="auto" />

      <Flex gap="8" flexDir="column" align="center">
        <Flex gap="1" flexDir="column" align="center" textAlign="center" maxW="2xl">
          <Text fontSize="md" fontWeight={[500, null, null, 600]} color="#131313">
            {t(`trivia.score.${challenge.topic}.winner.demo.subheading`)}
          </Text>

          <Text fontSize={['22px', null, null, '34px']} fontWeight="800" color="#131313">
            {t(`trivia.score.${challenge.topic}.winner.demo.heading`)}
          </Text>
        </Flex>

        <Button
          as={NextLink}
          href={returnURL}
          locale={prevAppLanguage}
          h="14"
          gap={[8, 12, 16]}
          justifyContent="space-between"
          fontSize="md"
          fontWeight="bold"
          color="white"
        >
          {t('trivia.pick-game')}

          <CrownIcon />
        </Button>
      </Flex>
    </Container>
  );
}
